/* global Sys, Services */
Sys.ns("Services");

/**
 * The FreeSpins Service.
 *
 * @class Services.FreeSpins
 * @extends Services.Base
 */
Services.FreeSpins = {
    constructor: function(config) {
        Services.FreeSpins.superclass.constructor.apply(this, arguments);
        this._isActive = false;
        this._freeSpinsLeft = 0;
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:freeSpinIntro.closed": this.setFreeSpinsStarted.bind(this),
            "notify:freeSpinOutro.closed": this.setFreeSpinsEnded.bind(this)
        });
    },

    /**
     * Gets the state of freespins.
     *
     * @returns {boolean} Is freeSpins responded by the game server.
     */
    isActive: function() {
        return this._isActive;
    },

    /**
     * Sets the number of freespins left.
     *
     * @param {number} freespinsLeft The number of freespins left.
     * @returns {void}
     */
    setFreeSpinsLeft: function(freespinsLeft) {
        this._freeSpinsLeft = freespinsLeft;
    },

    /**
     * Notify to update freeSpins count.
     *
     * @returns {void}
     */
    updateCounter: function() {
        this.publish("changed");
    },

    /**
     * Gets the number of freespins left.
     *
     * @returns {number} The remaining free spins or 0.
     */
    getFreeSpinsLeft: function() {
        return this._freeSpinsLeft;
    },

    /**
     * Notify to show counter.
     *
     * @returns {void}
     */
    showCounter: function() {
        this.publish("show");
    },

    /**
     * Notify to hide counter.
     *
     * @returns {void}
     */
    hideCounter: function() {
        this.publish("hide");
    },

    /**
     * Sets the mode of freespins to stated.
     *
     * @returns {void}
     */
    setFreeSpinsStarted: function() {
        this._isActive = true;
        this.publish("started", this._freeSpinsLeft);
    },

    /**
     * Sets the mode of freespins to ended.
     *
     * @returns {void}
     */
    setFreeSpinsEnded: function() {
        this._isActive = false;
        this.publish("ended");
    }
};

Services.FreeSpins = Sys.extend(
    Services.Base,
    Services.FreeSpins,
    "Services.FreeSpins"
);
